import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Api} from '../../providers/api';
import {NgxSpinnerService} from 'ngx-spinner';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {PROVINCIAS, Provincia, Ciudad} from './ubicaciones-argentina';


@Component({
  selector: 'app-modal-equipo',
  templateUrl: './modal-equipo.component.html',
  styleUrls: ['./modal-equipo.component.css']
})
export class ModalEquipoComponent implements OnInit {

  @Output()
  onclose = new EventEmitter();

  @Output()
  onsuccess = new EventEmitter<any>();

  @Input()
  grupos;

  @Input()
  item;

  nombre;
  modelo;
  ubicacion;
  sdFecha;
  selected_grupo;

  // Selectores de ubicación
  provincias = PROVINCIAS;
  selectedProvincia: Provincia = null;
  ciudadesFiltradas: Ciudad[] = [];
  selectedCiudad: Ciudad = null;

  nombre_validar;

  value = null;

  constructor(config: NgbDropdownConfig, private api: Api, private spinner: NgxSpinnerService) {
    config.placement = 'bottom';
    config.autoClose = true;
  }

  ngOnInit() {
    console.log(this.item);
    this.value = this.item.value;
    this.nombre = this.value.nombre;
    this.modelo = this.value.modelo;
    this.ubicacion = this.value.coordenadas || this.value.ubicacion || '';
    this.value.ubicacion = this.ubicacion;
    this.sdFecha = this.value.sdFecha;
    this.grupos.forEach((grupo, index) => {
      if (grupo.id === this.value.idGrupo) {
        this.selected_grupo = this.grupos[index];
      }
    });

    // Restaurar provincia/ciudad desde coordenadas guardadas
    if (this.ubicacion && this.ubicacion.indexOf(',') > 0) {
      for (const prov of this.provincias) {
        const match = prov.ciudades.find(c => c.coords === this.ubicacion);
        if (match) {
          this.selectedProvincia = prov;
          this.ciudadesFiltradas = prov.ciudades;
          this.selectedCiudad = match;
          break;
        }
      }
    }
  }

  onProvinciaChange() {
    this.ciudadesFiltradas = this.selectedProvincia
      ? this.selectedProvincia.ciudades
      : [];
    this.selectedCiudad = null;
    this.ubicacion = '';
  }

  onCiudadChange() {
    this.ubicacion = this.selectedCiudad ? this.selectedCiudad.coords : '';
    this.value.ubicacion = this.ubicacion;
  }

  close() {
    this.onclose.emit();
  }

  success() {
    const value = this.item.value;
    value.nombre = this.nombre;
    value.modelo = this.modelo;
    value.ubicacion = this.selectedCiudad ? this.selectedCiudad.coords : '';
    value.sdFecha = moment(this.sdFecha).format('YYYY-MM-DD');
    value.idGrupo = this.selected_grupo.id;
    this.onsuccess.emit(value);
  }

  selectGrupo(grupo) {
    this.selected_grupo = grupo;
  }

  getGrupoNombre(id) {
    let name;
    this.grupos.forEach((grupo) => {
      if (grupo.id === id) {
        name = grupo.nombre;
      }
    });
    return;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/modal-equipo/modal-equipo.component.ts